import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/_components/Braze/BrazeInitializer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/_components/Breadcrumb/BreadcrumbPageViewReporter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/_components/Google/GoogleAnalyticsClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/_components/Google/GoogleTagManager.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/_components/Meta/MetaPixelInitializer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/_components/NewRelic/BrowserMonitoringInitializer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/_components/PreviousPathnameTracker.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/global.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@americastestkitchen/mise/dist/styles.css");
;
import(/* webpackMode: "eager" */ "/app/mise/src/styles/styles.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@americastestkitchen/ui/dist/styles.css");
;
import(/* webpackMode: "eager" */ "/app/app/_styles/Shared.module.scss");
;
import(/* webpackMode: "eager" */ "/app/app/recipes/[slug]/_components/header/favorites-popup-legacy.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
